import React from "react";
import { graphql, Link } from "gatsby";
import { GraphQLResponse } from "../models";
import { Layout } from "../layouts";
import PageHeader from "../components/core/PageHeader";
import { Container } from "../components/core/Container/styled";
import { InsightListItem } from "../components/insights/ListItem";

interface InsightsProps {
  title: string;
  description: string;
}

interface InsightsPageProps extends GraphQLResponse<InsightsProps> {}

const InsightsPage = (props: InsightsPageProps) => {
  const { title, description } =
    props.data.allFile.edges[0].node.childMarkdownRemark.frontmatter;

  return (
    <Layout title={"Projects"}>
      <PageHeader title={title} description={description} textAlign="center" />
      <Container size="small">
        {props.data.allMarkdownRemark.edges.map((edge) => {
          return (
            <InsightListItem
              fields={edge.node.fields}
              frontmatter={edge.node.frontmatter}
            />
          );
        })}
      </Container>
    </Layout>
  );
};

export const query = graphql`
  query {
    allFile(
      filter: {
        sourceInstanceName: { eq: "content" }
        name: { eq: "insights" }
      }
    ) {
      edges {
        node {
          childMarkdownRemark {
            frontmatter {
              title
              description
            }
          }
        }
      }
    }
    allMarkdownRemark(
      sort: { fields: [frontmatter___date], order: DESC }
      filter: { frontmatter: { layout: { eq: "insights" } } }
    ) {
      totalCount
      edges {
        node {
          fields {
            slug
          }
          frontmatter {
            title
            summary
            date
          }
        }
      }
    }
  }
`;

export default InsightsPage;
